import * as React from "react";
import invariant from "invariant";
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
//import { Transition } from "react-transition-group";
//import StepAccomplished from '../../icons/v3/StepAccomplished';
import StepAccomplished from '../../icons/v3/BlueCheckBox';
import StepNotAccomplished from '../../icons/v3/StepNotAccomplished';
import LastStationAccomplished from '../../icons/v3/LastStationAccomplished';
import LastStationNotAccomplished from '../../icons/v3/LastStationNotAccomplished';

export class Step extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const {
            title,
            isFirst,
            isLast,
            isAccomplished,
        } = this.props;

        if (isLast) {
            const icon = isAccomplished ? <LastStationAccomplished /> : <LastStationNotAccomplished />
            return (
                <div style={{
                    marginTop: '15px', marginRight: '-6px',
                    display: 'flex', flexDirection: 'column', alignItems: 'center'
                }}>
                    {icon}
                    <div style={{ marginTop: '10px' }}>
                        {title}
                    </div>
                </div>);
        } else if (isFirst) {
            const icon = <div style={{ backgroundImage: `url(${`../../../Assets/Images/V3Design/BlueBadgeWhite.png`})`, width: '40px', height: '38px' }} />;
            return (
                <div style={{
                    marginTop: '24px', marginLeft: '-6px',
                    display: 'flex', flexDirection: 'column'
                }}>
                    {icon}
                    <div style={{ marginTop: '10px' }}>
                        {title}
                    </div>
                </div >);
        } else {
            const icon = isAccomplished ? <div style={{ backgroundImage: `url(${`../../../Assets/Images/V3Design/BlueBadgeWhite.png`})`, width: '40px', height: '38px' }} /> : <StepNotAccomplished />
            return (
                <div style={{
                    marginTop: '24px', marginLeft: '-6px',
                    display: 'flex', flexDirection: 'column', alignItems: 'center'
                }}>
                    {icon}
                    <div style={{ marginTop: '10px' }}>
                        {title}
                    </div>
                </div >);
        }
    }
}